module.exports = __webpack_public_path__ + "img/2f112c2.jpg";